import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { isNull, isArray, concat, trim, isUndefined } from 'lodash';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  Select,
} from '~/components/Form';

import { GFO } from '~/constants/perfil';

import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

function Relabastecimentodoorgaonoperiodo() {
  const [open, setOpen] = useState(true);

  const [valueOrgao, setValueOrgao] = React.useState('');
  const [valueProduto, setValueProduto] = React.useState('');
  const [disableOrgao, setDisableOrgao] = useState(false);
  const [orgaNome, setOrgaNome] = React.useState('');


  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (profile.glousuariotipo === GFO) {
        setValueOrgao({ orga_codigo: profile.glousuarioorgacodigo, orga_nome: profile.glousuarioorganome });
        setOrgaNome(profile.glousuarioorganome);
        setDisableOrgao(true);
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, [profile]);


  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        // datahorainicial: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        // datahorafinal: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),

        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
        orga_codigo: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }




  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let orgao = '';
    if (params.orga_codigo) {
      orgao = params.orga_codigo;
    } else {
      orgao = '0';
    }

    let orgaostr = '';
    if (params.orga_nome) {
      orgaostr = params.orga_nome;
    } else {
      orgaostr = '';
    }

    let produto = '';
    if (params.prod_codigo) {
      produto = params.prod_codigo;
    } else {
      produto = '';
    }

    let produtostr = '';
    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    } else {
      produtostr = '';
    }

    let agrupamento = '';
    if (params.abastecimentoagrupamento) {
      agrupamento = params.abastecimentoagrupamento;
    } else {
      agrupamento = '1';
    }

    let agrupamentostr = '';
    if (params.abastecimentoagrupamento) {
      agrupamentostr = params.abastecimentoagrupamento;
    } else {
      agrupamentostr = '';
    }

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,

      orgao,
      orgaostr,

      produto,
      produtostr,
      agrupamento,
      agrupamentostr,

      tipo,
    };
  }

  const onSerializeData = useCallback(

    (data) => ({
      ...data,
      orgao: valueOrgao.orga_codigo ? valueOrgao.orga_codigo : '',
      orgaostr: valueOrgao.orga_nome ? valueOrgao.orga_nome : '',
      produto: valueProduto.prod_codigo ? valueProduto.prod_codigo : '',
      produtostr: valueProduto.prod_descricao ? valueProduto.prod_descricao : '',
      agrupamento: data.agrupamento ? data.agrupamento : '1'
    })
    , [valueOrgao, valueProduto]
  )

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Abastecimentos do Órgão no Período - Volume"
      relatorio="abastecimentosorgaoperiodovolume"
      validate={(param) => handleValidate(param)}
      serialize={onSerializeData}
      initials={{
        datahorainicial,
        datahorafinal,
        orga_codigo: valueOrgao.orga_codigo,
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />

      <DateTime time label="Data Final" name="datahorafinal" /> */}

      {/* <Autocomplete
        name="orgao"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        getValue={value => setValueOrgao(value)}
      /> */}

      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="orga_codigo"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        inputValue={valueOrgao !== undefined ? valueOrgao.orga_nome : ''}
        onInputChange={(event, value) => {
          let obj = {
            ...valueOrgao,
            orga_nome: value,
          }
          setValueOrgao(obj);
        }}
        hiddens={[{ name: 'orga_nome' }]}
        getValue={(value) => {
          if (isNull(value.orga_nome)) setValueOrgao({ orga_codigo: '', orga_nome: '' });
          else setValueOrgao(value);
        }}
        disabled={disableOrgao}
      />

      <Autocomplete
        name="produto"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        getValue={value => setValueProduto(value)}
      />

      <Select
        name="agrupamento"
        variant="outlined"
        size="small"
        label="Agrupamento"
        defaultValue="1"
        options={[
          { value: '1', label: 'Listagem' },
          { value: '2', label: 'Unidade' },
        ]}
      />

      <RadioGroup
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimentodoorgaonoperiodo;
